import { useEffect, useState, useTransition } from 'react';

import { fetchScheduleNames } from './api';

export function useLoadScheduleNames() {
	const [list, setList] = useState<string[]>([]);
	const [isPending, startTransition] = useTransition();

	useEffect(() => {
		startTransition(async () => {
			const data = await fetchScheduleNames();
			setList(data);
		});
	}, []);

	return { list, isPending };
}
